import { render, staticRenderFns } from "./SwitchProvider.vue?vue&type=template&id=24b281da&scoped=true&"
import script from "./SwitchProvider.vue?vue&type=script&lang=js&"
export * from "./SwitchProvider.vue?vue&type=script&lang=js&"
import style0 from "./SwitchProvider.vue?vue&type=style&index=0&id=24b281da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b281da",
  null
  
)

export default component.exports